module.exports = __webpack_public_path__ + "images/groups-img-desktop.48aa9c2bc7192d78f6bbd51db19a6d24.png";